import api from '~/services/api';

async function showBlood(id) {
  const response = await api.get(`/bloods/${id}`);

  return response;
}

async function calendarBloods({ date, userId = undefined }) {
  const response = await api.get('/calendar/bloods', {
    params: {
      date,
      userId,
    },
  });

  return { bloods: response.data, dates: response.data.map((i) => i.date) };
}

async function calendarShow({ date, userId = undefined }) {
  const response = await api.get(`/calendar/bloods/${date}`, {
    params: {
      userId,
    },
  });

  return { bloods: response.data };
}

export { showBlood, calendarBloods, calendarShow };
